/* SET STATE */
export const SET_STATE_NOTIFICATIONRESPONSIBLE = "SET_STATE_NOTIFICATIONRESPONSIBLE"

/* NOTIFICATIONRESPONSIBLES */
export const GET_NOTIFICATIONRESPONSIBLES = "GET_NOTIFICATIONRESPONSIBLES"
export const GET_NOTIFICATIONRESPONSIBLES_SUCCESS = "GET_NOTIFICATIONRESPONSIBLES_SUCCESS"
export const GET_NOTIFICATIONRESPONSIBLES_FAIL = "GET_NOTIFICATIONRESPONSIBLES_FAIL"

/* NOTIFICATIONRESPONSIBLE */
export const GET_NOTIFICATIONRESPONSIBLE = "GET_NOTIFICATIONRESPONSIBLE"
export const GET_NOTIFICATIONRESPONSIBLE_SUCCESS = "GET_NOTIFICATIONRESPONSIBLE_SUCCESS"
export const GET_NOTIFICATIONRESPONSIBLE_FAIL = "GET_NOTIFICATIONRESPONSIBLE_FAIL"

/**
 * ADD NOTIFICATIONRESPONSIBLE
 */
 export const ADD_NEW_NOTIFICATIONRESPONSIBLE = "ADD_NEW_NOTIFICATIONRESPONSIBLE"
 export const ADD_NOTIFICATIONRESPONSIBLE_SUCCESS = "ADD_NOTIFICATIONRESPONSIBLE_SUCCESS"
 export const ADD_NOTIFICATIONRESPONSIBLE_FAIL = "ADD_NOTIFICATIONRESPONSIBLE_FAIL"

 /**
 * UPDATE NOTIFICATIONRESPONSIBLE
 */
export const UPDATE_NOTIFICATIONRESPONSIBLE = "UPDATE_NOTIFICATIONRESPONSIBLE"
export const UPDATE_NOTIFICATIONRESPONSIBLE_SUCCESS = "UPDATE_NOTIFICATIONRESPONSIBLE_SUCCESS"
export const UPDATE_NOTIFICATIONRESPONSIBLE_FAIL = "UPDATE_NOTIFICATIONRESPONSIBLE_FAIL"

/**
 * DELETE NOTIFICATIONRESPONSIBLE
 */
export const DELETE_NOTIFICATIONRESPONSIBLE = "DELETE_NOTIFICATIONRESPONSIBLE"
export const DELETE_NOTIFICATIONRESPONSIBLE_SUCCESS = "DELETE_NOTIFICATIONRESPONSIBLE_SUCCESS"
export const DELETE_NOTIFICATIONRESPONSIBLE_FAIL = "DELETE_NOTIFICATIONRESPONSIBLE_FAIL"
